import { FC, ReactNode } from 'react';
import { Box, Stack, Typography, useTheme } from '@mui/material';

import { MplButton } from '../../atoms/MplButton/MplButton';

interface IMplActionCardProps {
	title: string;
	description?: string | ReactNode;
	ctaText: string;
	onCtaClick: () => void;
	buttonTestId?: string;
}

export const MplActionCard: FC<IMplActionCardProps> = ({
	title,
	description,
	ctaText,
	onCtaClick,
	buttonTestId,
}) => {
	const theme = useTheme();

	return (
		<Stack
			spacing={2}
			sx={{
				boxSizing: 'border-box',
				width: '100%',
				padding: '16px',
				border: `1px solid ${theme.palette.solutions?.[100]}`,
				backgroundColor: theme.palette.neutral?.[0],
				borderRadius: '8px',
				boxShadow:
					'0px 8px 8px -4px rgba(24, 39, 75, 0.08), 0px 4px 6px -4px rgba(24, 39, 75, 0.12)',
			}}
		>
			<Stack spacing={description ? 0.5 : 0}>
				<Typography variant="h4-sb" color={theme.palette.primary.main}>
					{title}
				</Typography>

				{!!description && (
					<Typography variant="b2" color={theme.palette.solutions?.[600]}>
						{description}
					</Typography>
				)}
			</Stack>

			<Box>
				<MplButton
					variant="contained"
					fullWidth
					onClick={onCtaClick}
					testId={buttonTestId}
				>
					<Typography variant="bu1-m">{ctaText}</Typography>
				</MplButton>
			</Box>
		</Stack>
	);
};
